import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeSidebarMenus } from '../../actions/common';
import { addEntity } from '../../actions/grid-screen';
import {
    AddCampaignTypeMenu,
    AddCampaignTypeMenuProps
} from '../../components/AddCampaignTypeMenu/AddCampaignTypeMenu';
import { CampaignType } from '../../typings/domain';
import { GridEditedEntityType } from '../../typings/grid';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

type StateProps = TStateProps<AddCampaignTypeMenuProps> & {
    clientLogin?: string;
};

type DispatchProps = {
    onClick: (campaignType: CampaignType, login: string) => void;
};

type MergedProps = AddCampaignTypeMenuProps;

const mapStateToProps = (state: State): StateProps => {
    const clientLogin = state.commonData.client.login;
    const { availableCampaignTypes = [] } = state.commonData;

    return {
        clientLogin,
        availableCampaignTypes
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onClick(campaignType: CampaignType, login: string) {
            dispatch(closeSidebarMenus());
            dispatch(
                addEntity({
                    type: GridEditedEntityType.Campaign,
                    campaignType,
                    login
                })
            );
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps
): MergedProps => {
    const { clientLogin, ...filteredStateProps } = stateProps;
    const { onClick, ...filteredDispatchProps } = dispatchProps;
    return {
        ...filteredStateProps,
        ...filteredDispatchProps,
        onClick: clientLogin
            ? (type: CampaignType) => {
                  onClick(type, clientLogin);
              }
            : undefined
    };
};

export const AddCampaignTypeMenuContainer = connect<
    StateProps,
    DispatchProps,
    {},
    MergedProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(AddCampaignTypeMenu);
